import {UmpireImage} from '../umpire-image';
import {UmpireProductCategory} from '../umpire-product-category';

export interface UmpireProduct {
  id?: string;
  type?: string;
  relationships?: string[];
  image: UmpireImage | null;
  external_url: string;
  is_draft: boolean;
  name: string;
  price: number;
  promotion_description: string;
  promotion_price: number;
  publication_time: string | null;
  published_at?: string | null;
  is_on_promotion: boolean;
  category: UmpireProductCategory | null;
}
